import { getRequest, postRequest } from '../httpclient/httpClient';

const SUBSCRIBER_SETTING_PATH = 'subscription/subscriber_setting';
const TAXES_PATH = 'subscription/taxes';
const DEFAULT_TAX_PATH = 'subscription/default_tax';
const DEFAULT_DATA_DISPLAY_PERIOD_PATH = 'subscription/defaultDataDisplayPeriod';
const CURRENT_SUBSCRIPTION_PATH = 'subscription/current';
const ACTIVE_USERS_PATH = 'subscription/active_users';
const PAYMENTS_PATH = 'subscription/payments';
const STATES_PATH = 'subscription/states';
const PAYMENT_METHOD_PATH = 'subscription/payment-method';

const EMPTY_INVOICE = {
  companyName: '',
  address: '',
  city: '',
  zip: '',
  regionId: ''
};

export async function subscriberSettings() {
  const subscriberSettingResponse = await getRequest(SUBSCRIBER_SETTING_PATH);
  console.log(subscriberSettingResponse);
}

export async function taxes() {
  const response = await getRequest(TAXES_PATH);
  return response.data;
}

export async function defaultTax() {
  const response = await getRequest(DEFAULT_TAX_PATH);
  return response.data;
}

export async function defaultDataDisplayPeriod() {
  const response = await getRequest(DEFAULT_DATA_DISPLAY_PERIOD_PATH);
  return response.data;
}

function normalizeCurrentSubscription(data) {
  return {
    ...data,
    additionalUsersAllowed: Boolean(data?.additionalUsersAllowed),
    invoice: {
      ...EMPTY_INVOICE,
      ...(data?.invoice || {})
    }
  };
}

export function totalUsersExceededMessage(error, t) {
  if (error?.response?.data?.messageKey !== 'user_count_exceeds_total_users') {
    return null;
  }
  const match = String(error.response.data.message || '').match(/\((\d+)\)/);
  const text = t('user_count_exceeds_total_users');
  return match ? `${text} (${match[1]})` : text;
}

export async function getCurrentSubscription() {
  const response = await getRequest(CURRENT_SUBSCRIPTION_PATH);
  return normalizeCurrentSubscription(response.data);
}

export async function getRegions() {
  const response = await getRequest(STATES_PATH);
  return Array.isArray(response.data) ? response.data : [];
}

export async function getActiveUsers(params = {}) {
  const response = await getRequest(ACTIVE_USERS_PATH, { params });
  return response.data;
}

export async function getPaymentHistory() {
  const response = await getRequest(PAYMENTS_PATH);
  return Array.isArray(response.data) ? response.data : [];
}

export async function downloadPaymentInvoice(paymentId) {
  const response = await getRequest(`${PAYMENTS_PATH}/${paymentId}/invoice`, { responseType: 'blob' });
  return response;
}

export async function savePaymentMethod(values) {
  const response = await postRequest(PAYMENT_METHOD_PATH, {
    token: values.token,
    cardName: values.cardName,
    companyName: values.companyName,
    address: values.address,
    city: values.city,
    zip: values.zip,
    regionId: values.regionId
  });
  return normalizeCurrentSubscription(response.data);
}
